import {API, ApiRequestOptions} from "@/classes/api/api.class";
import {
    CreateEmployeeContractTemplateRequestDto,
} from "@/classes/dto/contract-manager/employee-contract-template/CreateEmployeeContractTemplate.request.dto";
import {LeanDocument, Types} from "mongoose";
import {FindByIdOptionsRequestDto} from "@/classes/dto/_common/request/FindByIdOptions.request.dto";
import {EmployeeContractDocument} from "@/documentTypes/contract-manager/EmployeeContract.document";
import {
    FindEmployeeContractTemplateRequestDto,
} from "@/classes/dto/contract-manager/employee-contract-template/FindEmployeeContractTemplate.request.dto";
import {
    UpdateEmployeeContractTemplateRequestDto,
} from '@/classes/dto/contract-manager/employee-contract-template/UpdateEmployeeContractTemplate.request.dto';
import {
    CreateEmployeeContractRequestDto,
} from '@/classes/dto/contract-manager/employee-contract/CreateEmployeeContract.request.dto';
import {EmployeeContractTemplateDocument} from '@/documentTypes/contract-manager/EmployeeContractTemplate.document';
import {
    FindEmployeeContractRequestDto,
} from '@/classes/dto/contract-manager/employee-contract/FindEmployeeContract.request.dto';
import {
    UpdateEmployeeContractRequestDto,
} from '@/classes/dto/contract-manager/employee-contract/UpdateEmployeeContract.request.dto';

/** GET employee-contracts/status: yes / no per employee (employees missing in the answer are unknown – no right) */
export type EmployeeContractStatus = {
    employee: string;
    hasContract: boolean;
    firstContractStart?: Date;
    /** Only with withActiveCourses */
    activeCourses?: number;
};

export class ContractManagerApi extends API {
    static service = 'contract-manager';

    static employeeContractTemplates = {
        create: async (data: CreateEmployeeContractTemplateRequestDto): Promise<Types.ObjectId> => {
            return ContractManagerApi.post('employee-contract-templates', data)
        },
        findById: async (id: Types.ObjectId, options?: FindByIdOptionsRequestDto): Promise<LeanDocument<EmployeeContractTemplateDocument>> => {
            return ContractManagerApi.get(`employee-contract-templates/${id}`, options);
        },
        find: async (data: FindEmployeeContractTemplateRequestDto): Promise<{
            employeeContractTemplates: LeanDocument<EmployeeContractTemplateDocument>[];
            maxPage: number
        }> => {
            return ContractManagerApi.get(`employee-contract-templates`, data);
        },
        update: async (id: Types.ObjectId, data: UpdateEmployeeContractTemplateRequestDto): Promise<Types.ObjectId> => {
            return ContractManagerApi.put(`employee-contract-templates/${id}`, data);
        },
        delete: async (id: Types.ObjectId): Promise<Types.ObjectId> => {
            return ContractManagerApi.delete(`employee-contract-templates/${id}`);
        },
    }

    static employeeContracts = {
        create: async (data: CreateEmployeeContractRequestDto): Promise<Types.ObjectId> => {
            return ContractManagerApi.post('employee-contracts', data)
        },
        findById: async (id: Types.ObjectId, options?: FindByIdOptionsRequestDto): Promise<LeanDocument<EmployeeContractDocument>> => {
            return ContractManagerApi.get(`employee-contracts/${id}`, options);
        },
        find: async (data: FindEmployeeContractRequestDto): Promise<{
            employeeContracts: LeanDocument<EmployeeContractDocument>[];
            maxPage: number
        }> => {
            return ContractManagerApi.get(`employee-contracts`, data);
        },
        update: async (id: Types.ObjectId, data: UpdateEmployeeContractRequestDto): Promise<Types.ObjectId> => {
            return ContractManagerApi.put(`employee-contracts/${id}`, data);
        },
        delete: async (id: Types.ObjectId): Promise<Types.ObjectId> => {
            return ContractManagerApi.delete(`employee-contracts/${id}`);
        },
        /** Batched contract status (max. 500 ids); options.handledStatuses: the hint is optional, no error dialog */
        status: async (data: { employees: string[]; withActiveCourses?: boolean }, options?: ApiRequestOptions): Promise<{ statuses: EmployeeContractStatus[] }> => {
            return ContractManagerApi.get('employee-contracts/status', data, undefined, options);
        },
    }
}
